import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { proposalAPI } from "../../api/gms/proposal/proposal-api";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { useConflictProposalDataState } from "../data-state/use-conflict-proposal-data-state";

interface SocketPayload {
    proposalId: number;
}

export const useRequestExistingGroupListSocket = () => {
    const dispatch = useDispatch();

    const { conflictProposalId } = useConflictProposalDataState()

        const invalidate = useCallback(
        (payload?: SocketPayload | null) => {
            // Always refresh the Existing Group request list.
            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "RequestExistingGroup", id: "LIST" },
                ])
            );

            // Always refresh the Proposal list too.
            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "Proposal", id: "LIST" },
                ])
            );

            // Safely support either payload ID property.
            const proposalId = payload?.proposalId ?? payload?.proposalId;

            // Refresh the currently opened Existing Group request, if applicable.
            if (
                proposalId == null ||
                Number(proposalId) !== Number(conflictProposalId)
            ) {
                return;
            }

            dispatch(
                proposalAPI.util.invalidateTags([
                    { type: "RequestExistingGroup", id: proposalId },
                ])
            );
        },
        [dispatch, conflictProposalId]
    );

    useEffect(() => {
        if (!socketSetup) return;

        const events = [
            "transferApplicationOwnership",

            "conflictProposalForApproval",
            "createApplication",
            "uploadExcelFile",
            "uploadSupportingDetails",
            "updateApplication",
            "updateApplicationStatus",
            "saveDraft",

            "approveConflictProposal",
            "conflictProposalApproved",
            "rejectConflictProposal",
            "conflictProposalDeclined",
        ];

        events.forEach((event) => {
            socketSetup.on(event, invalidate);
        });

        return () => {
            events.forEach((event) => {
                socketSetup.off(event, invalidate);
            });
        };
    }, [invalidate]);
};